module.exports = __webpack_public_path__ + "static/media/antoine-similon-1165697-unsplash-cr.54dbeefb.jpg";